export const common = {
  companyName: 'Komatsu Spring Industrial Co., Ltd.',
  companyNameEn: 'Komatsu Spring Industrial Co., Ltd.',
  slogan: 'Delicate Design & Reliable Quality',
  heroTagline: 'The Spring Specialist, Chosen for Quality',
  heroSubtitle: 'Custom spring manufacturing tailored to your exact requirements',
  productInfo: 'Products & Applications',
  companyProfile: 'Company Profile',
  blog: 'Blog',
  contact: 'Contact Us',
  recruit: 'Careers & Recruitment',
  news: 'News & Updates',
  newsAll: 'View All News',
  torsionSpring: 'Torsion Spring',
  compressionSpring: 'Compression Spring',
  tensionSpring: 'Tension Spring',
  wireForming: 'Wire Forming',
  torsionSpringEn: 'TORSION SPRING',
  compressionSpringEn: 'COMPRESSION SPRING',
  tensionSpringEn: 'TENSION SPRING',
  wireFormingEn: 'WIRE FORMINGS',
  address: '5-3-18 Omoriminami, Ota-ku, Tokyo 143-0013, Japan',
  tel: 'Tel: 03-3743-0231',
  fax: 'Fax: 03-3743-0235',
  copyright: '© Komatsu Spring Industrial Co., Ltd.',
  features: 'Features',
  springTypes: 'Spring Types',
  products: 'Products',
  usage: 'Applications',
  message: 'President\'s Message',
  companySummary: 'Company Overview',
  equipment: 'Equipment List',
  office: 'Offices & Factories',
  history: 'History & Milestones',
  quality: 'Quality/Environmental Policy',
  esg: 'ESG',
  registrations: 'Registrations',
  japanese: '日本語',
  english: 'English',
  chinese: '中文(简体)',
  chineseTraditional: '中文(繁體)',
  
  // Footer translations
  companyAddress: '5-3-18 Omorominami, Ota-ku, Tokyo 143-0013, Japan',
  quickLinks: 'Quick Links',
  home: 'Home',
  businessHours: 'Business Hours',
  businessHoursDetail: 'Monday to Friday 8:30-17:30 (Closed on weekends and holidays)',
  footerRights: 'All rights reserved.',
  
  // Features page content
  featuresTitle: 'Our Features',
  featuresSubtitle: 'Our high-quality springs are born from delicate conception and thorough customer-first principles.',
  delicateDesign: 'Delicate Conception',
  delicateDesignDesc: 'We engage in technical development based on the concept that "even a single small spring is an important component that forms the heart of precision products."',
  prototypeToMass: 'From Prototype to Mass Production',
  prototypeToMassDesc1: 'We accept orders starting from a single prototype.',
  prototypeToMassDesc2: 'We ensure the same quality during mass production by manufacturing prototypes using the same machinery setup.',
  qualityControl: 'Thorough Quality Control',
  qualityControlDesc1: 'Quality Built in the Factory:',
  qualityControlDesc1Detail: 'We establish thorough management and inspection systems at each stage from order receipt through manufacturing to delivery, enabling more comprehensive product creation.',
  qualityControlDesc2: 'Quality Assurance:',
  qualityControlDesc2Detail: 'We provide "Product Inspection Reports" that guarantee reliable quality at the time of product delivery.',
  qualityControlDesc3: 'Delivery Management:',
  qualityControlDesc3Detail: 'We implement thorough delivery management utilizing computer systems.',
  qualityControlDesc4: 'Quality Maintenance:',
  qualityControlDesc4Detail: 'We can maintain high-precision quality by manufacturing jigs, tools, and molds in-house.',
  // Products page content
  productsTitle: 'Spring Types, Products & Applications',
  productsSubtitle: '1000 technologies for 1000 different needs',
  detailInfo: 'Detailed information and videos are available from the links below.',
  torsionSpringDetail: 'Torsion Springs',
  compressionSpringDetail: 'Compression Springs',
  tensionSpringDetail: 'Tension Springs',
  wireFormingDetail: 'Wire Forming',
  microSpring: 'Micro Springs & Medical Special Springs',
  otherProducts: 'Others & Non-Industrial Products',
  torsionSpringDesc: 'Torsion springs receive torsional loads (torque) around the central axis of the coil.',
  torsionSpringSpec: 'Manufacturing Record: Wire diameter 0.03mm to 2.0mm, round wire',
  compressionSpringDesc: 'Generally called push springs, this type of spring has compression load (coil axial load) proportional to deflection.',
  compressionSpringSpec1: 'Manufacturing Record: Wire diameter 0.02mm to 2.0mm, round wire, flat wire',
  compressionSpringSpec2: 'Shape Record: Long coil, conical, barrel-shaped, unequal pitch, unequal outer diameter',
  tensionSpringDesc: 'Tension coil springs are essentially the same as compression springs. (Coil parts are generally close-wound)',
  tensionSpringSpec: 'Manufacturing Record: Wire diameter 0.08mm to 2.0mm',
  wireFormingDesc: 'Wire craft springs that are variously shaped using forming machines and other equipment',
  wireFormingSpec1: 'Manufacturing Record: Wire diameter 0.1mm to 2mm',
  wireFormingSpec2: 'Material Shape: Round wire, flat wire',
  materials: 'Materials',
  materialTypes: 'Piano wire, stainless steel wire, platinum wire, phosphor bronze wire, various plated wires, others',
  materialShapes: 'Round wire, flat wire',
  builtInProducts: 'Built-in Product Examples',
  builtInProductsSubtitle: 'Used in various products',
  electricalProducts: 'Electrical Products',
  electricalProductsList: 'Industrial products, home appliances, cameras, printers, gas equipment, fire alarms, electric meters, others',
  communication: 'Communication',
  communicationList: 'Mobile phones, charging stations, terminal blocks, clocks, others',
  medicalEquipment: 'Medical Equipment',
  medicalEquipmentList: 'Catheter treatment devices, endoscopic equipment, electrosurgical units, biopsy equipment, health devices, pulse oximeters, blood pressure monitors, scales, pedometers, beauty equipment, others',
  vehicleEquipment: 'Vehicle Equipment',
  vehicleEquipmentList: 'Automobiles, motorcycles, grass cutters, buses, others',
  otherUsage: 'Others',
  otherUsageList: 'Jewelry, locks, audio equipment, fishing gear, stationery, toys, furniture, others',
  usageTitle: 'Applications',
  usageSubtitle: 'Responding with technology tailored to each individual application',
  electricalUsage: 'Switches, connectors, battery conduction, conductive parts, contact probes, printer dot pins, sensors, others',
  communicationUsage: 'Watch crowns, watch date mechanisms, hinges, antennas, camera shutters, camera lens periphery, others',
  medicalUsage: 'Guide wires, endoscope insertion parts, projection markers, clips, biopsy machines, others',
  vehicleUsage: 'Carburetors, automotive electrical parts, brake switches, others',
  otherDetailUsage: 'Filters, fasteners, earrings, record needle arm supports, lure frames, reels, stationery clips, ballpoint pen parts, others',
  
  // Product detail pages common
  banner: 'Micro Science of Precision Equipment by Custom Manufacturing',
  clickToEnlarge: 'Click to enlarge',
  manufacturingRecord: 'Manufacturing Record',
  characteristics: 'Characteristics',
  mainApplications: 'Main Applications',
  technicalSpecs: 'Technical Specifications',
  qualityAssurance: 'Quality Assurance',
  contactUs: 'Contact Us',
  
  // Torsion Spring page - 追加
  torsionSpringApp1: 'Automotive door hinges',
  torsionSpringApp2: 'Washing machine lid opening/closing mechanisms',
  torsionSpringApp3: 'Electronic device cover opening/closing',
  torsionSpringApp4: 'Watch winding mechanisms',
  torsionSpringApp5: 'Toy drive parts',
  
  // Compression Spring page - 追加
  compressionSpringFeature: 'Compression springs are one of the most common types of springs, with the property of contracting when subjected to axial compression loads. The load and deflection are proportional, and they are used in various mechanical parts and electronic devices.',
  compressionSpringApp1: 'Automotive suspension',
  compressionSpringApp2: 'Ballpoint pen internal mechanisms',
  compressionSpringApp3: 'Electronic device switches',
  compressionSpringApp4: 'Medical device parts',
  compressionSpringApp5: 'Industrial machinery cushioning materials',
  hardWire: 'Hard steel wire (SWC)',
  flatWire: 'Flat wire material',
  specialShapes: 'Special Shape Support',
  conicalSpring: 'Conical spring (taper coil)',
  barrelSpring: 'Barrel spring',
  unevenPitch: 'Unequal pitch spring',
  unevenDiameter: 'Unequal outer diameter spring',
  longCoil: 'Long coil',
  squareWireSpring: 'Square wire spring',
  precisionMeasurement: 'Precision Measurement',
  precisionMeasurementDesc: 'Using micrometer-grade precision measuring equipment',
  loadTest: 'Load Test',
  loadTestDesc: 'Spring load testing performed on all lots',
  qualityCertificate: 'Quality Certificate',
  qualityCertificateDesc: 'Issue quality certificates with inspection data',
  
  // Tension Spring page
  tensionSpringFeature: 'Tension springs have the property of extending when subjected to axial tensile loads. The coil part is generally close-wound, and hook-shaped processing is applied to both ends. They are applied to applications that utilize force in the opposite direction to compression springs.',
  tensionSpringApp1: 'Meter needle return mechanism for measuring instruments',
  tensionSpringApp2: 'Door closers',
  tensionSpringApp3: 'Electronic component connection mechanisms',
  tensionSpringApp4: 'Medical device operating parts',
  tensionSpringApp5: 'Automotive cables',
  hookTypes: 'Hook Types',
  roundHook: 'Round Hook',
  roundHookDesc: 'Most common circular hook shape',
  angleHook: 'Angle Hook',
  angleHookDesc: 'Shape with adjustable angle',
  specialHook: 'Special Hook',
  specialHookDesc: 'Custom shape according to application',
  materialsList: 'Materials',
  pianoWire: 'Piano wire (SWP-A, SWP-B)',
  stainlessWire: 'Stainless steel wire (SUS304, SUS316)',
  phosphorBronze: 'Phosphor bronze wire',
  berylliumCopper: 'Beryllium copper wire',
  specialAlloy: 'Other special alloy wires',
  processingRange: 'Processing Range',
  wireDiameter: 'Wire Diameter',
  outerDiameter: 'Outer Diameter',
  freeLength: 'Free Length',
  effectiveCoils: 'Effective Coils: Negotiable',
  hookAccuracy: 'Hook Accuracy',
  hookAccuracyDesc: 'Strict management of hook shape dimensional accuracy',
  tensileTest: 'Tensile Test',
  tensileTestDesc: 'Tensile testing at specified loads for all products',
  durabilityTest: 'Durability Test',
  durabilityTestDesc: 'Verification of durability under repeated loads',
  
  // Wire Forming page
  wireFormingFeature: 'Wire forming is a technology that shapes wire materials into various forms. Using forming machines, we manufacture complex three-dimensional shaped parts with high precision. Also called "wire craft springs," they can accommodate diverse applications.',
  wireFormingApp1: 'Clips, staples',
  wireFormingApp2: 'Electronic component connection terminals',
  wireFormingApp3: 'Medical device fine parts',
  wireFormingApp4: 'Watch and precision instrument parts',
  wireFormingApp5: 'Decorative items and accessories',
  processingTypes: 'Processing Types',
  bendingProcess: 'Bending Process',
  bendingProcessDesc: 'Processing to bend straight material at any angle',
  coilingProcess: 'Coiling Process',
  coilingProcessDesc: 'Winding into spiral or coil shapes',
  cuttingProcess: 'Cutting Process',
  cuttingProcessDesc: 'Precision cutting to specified dimensions',
  formingProcess: 'Forming Process',
  formingProcessDesc: 'Complex three-dimensional shape forming',
  supportedMaterials: 'Supported Materials',
  highCarbonWire: 'Piano wire (high carbon steel wire)',
  stainlessVariety: 'Various stainless steel wires',
  copperWire: 'Copper wire, brass wire',
  titaniumWire: 'Titanium wire',
  platedWire: 'Various plated wires',
  materialShape: 'Material Shape: Round wire, flat wire',
  processingLength: 'Processing Length',
  accuracy: 'Accuracy',
  minBendRadius: 'Minimum Bend Radius: 1.5 times wire diameter',
  applicationFields: 'Application Fields',
  electronicPrecision: 'Electronic & Precision Equipment',
  connectionTerminals: 'Connection terminals, connectors',
  sensorParts: 'Sensor parts',
  boardFixing: 'Board fixing parts',
  switchMechanism: 'Switch mechanisms',
  medicalDevices: 'Medical Devices',
  catheterParts: 'Catheter parts',
  endoscopeParts: 'Endoscope parts',
  surgicalInstruments: 'Surgical instruments',
  inspectionParts: 'Inspection equipment parts',
  autoIndustrial: 'Automotive & Industrial Equipment',
  electricalParts: 'Electrical parts',
  fixingClips: 'Fixing clips',
  mechanismParts: 'Mechanism parts',
  dimensionInspection: 'Dimension Inspection',
  dimensionInspectionDesc: 'Precision dimensional inspection using 3D measuring equipment',
  appearanceInspection: 'Appearance Inspection',
  appearanceInspectionDesc: '100% inspection of surface quality and shape accuracy',
  functionalTest: 'Functional Test',
  functionalTestDesc: 'Operation verification test under practical conditions',
  
  // Micro Spring page
  microSpringDesc: 'We manufacture from ultra-small springs to special springs for medical devices using high-precision technology.',
  microSpringTitle: 'Micro Springs',
  microSpringEn: 'MICRO SPRING',
  medicalSpringTitle: 'Medical Special Springs',
  medicalSpringEn: 'MEDICAL SPECIAL SPRING',
  microFeature1: 'Using ultra-fine wire from 0.02mm diameter',
  microFeature2: 'Ultra-small springs with outer diameter of 1mm or less',
  microFeature3: 'Ideal for precision electronic equipment',
  microFeature4: 'High-precision dimensional control',
  microApp1: 'Watch internal mechanisms',
  microApp2: 'Precision measuring instruments',
  microApp3: 'Camera mechanism parts',
  microApp4: 'Micro switches',
  medicalFeature1: 'Using biocompatible materials',
  medicalFeature2: 'High safety and reliability',
  medicalFeature3: 'Custom design support',
  medicalFeature4: 'Strict quality control',
  medicalApp1: 'Catheter parts',
  medicalApp2: 'Endoscopic equipment',
  medicalApp3: 'Surgical instruments',
  medicalApp4: 'Biosensors',
  microSpringSpecs: 'Micro Spring Specifications',
  medicalMaterials: 'Medical Materials',
  biocompatibleStainless: 'Biocompatible stainless steel',
  titaniumAlloy: 'Titanium alloy: Lightweight, high-strength material',
  mp35n: 'MP35N: High-performance alloy',
  platinumWire: 'Platinum wire: High-purity material',
  manufacturingProcess: 'Manufacturing Process',
  materialSelection: 'Material Selection',
  materialSelectionDesc: 'Selection and verification of optimal materials according to application',
  precisionProcessing: 'Precision Processing',
  precisionProcessingDesc: 'High-precision forming using dedicated equipment',
  qualityInspection: 'Quality Inspection',
  qualityInspectionDesc: '100% inspection of dimensions, load, and appearance',
  cleanPackaging: 'Clean Packaging',
  cleanPackagingDesc: 'Final packaging in cleanroom environment',
  electronicDevices: 'Electronic Devices',
  electronicDevicesDesc: 'Internal parts for smartphones, tablets, wearable devices',
  medicalEquipmentDesc: 'Catheters, endoscopes, surgical instruments, inspection equipment',
  precisionInstruments: 'Precision Instruments',
  precisionInstrumentsDesc: 'Precision parts for watches, measuring instruments, optical equipment',
  opticalEquipment: 'Optical Equipment',
  opticalEquipmentDesc: 'Cameras, microscopes, lens drive mechanisms',
  automationEquipment: 'Automation Equipment',
  automationEquipmentDesc: 'Robots, precision actuators',
  analyticalInstruments: 'Analytical Instruments',
  analyticalInstrumentsDesc: 'Fine parts for analytical and inspection equipment',
  certifications: 'Quality Assurance & Certifications',
  isoCertification: 'ISO Certification',
  isoCertificationDesc: 'Compliant with international quality management standards',
  precisionInspectionTitle: 'Precision Inspection',
  precisionInspectionDesc: '100% inspection using latest measuring equipment',
  traceability: 'Traceability',
  traceabilityDesc: 'Complete management of manufacturing history',
  medicalCertification: 'Medical Certification',
  medicalCertificationDesc: 'Material certification for medical devices',
  
  // Other Products page
  otherProductsDesc: 'In addition to industrial products, we manufacture spring parts for various products used in daily life.',
  jewelryAccessories: 'Jewelry & Accessories',
  earringClasp: 'Earring clasps',
  necklaceClasp: 'Necklace clasps',
  broochClasp: 'Brooch clasps',
  watchBandParts: 'Watch band parts',
  stationery: 'Stationery',
  penMechanism: 'Ballpoint pen internal mechanisms',
  clipsBindings: 'Clips and binders',
  mechanicalPencil: 'Mechanical pencil parts',
  staplerParts: 'Stapler mechanism parts',
  toysHobbies: 'Toys & Hobbies',
  toyMechanism: 'Toy drive mechanisms',
  modelParts: 'Model movable parts',
  fishingReelParts: 'Fishing reel parts',
  lureFrame: 'Lure frames',
  furnitureInterior: 'Furniture & Interior',
  chairCushion: 'Chair seat cushions',
  sofaStructure: 'Sofa internal structure',
  drawerMechanism: 'Drawer opening/closing mechanisms',
  doorCloser: 'Door closers',
  audioEquipment: 'Audio Equipment',
  recordNeedleArm: 'Record needle arm supports',
  speakerDiaphragm: 'Speaker diaphragms',
  instrumentParts: 'Musical instrument parts',
  headphoneAdjustment: 'Headphone adjustment mechanisms',
  securityLocks: 'Security & Locks',
  lockMechanism: 'Lock internal mechanisms',
  padlockParts: 'Padlock parts',
  doorLock: 'Door lock mechanisms',
  securityDevice: 'Security devices',
  manufacturingFeatures: 'Manufacturing Features',
  customDesign: 'Custom Design',
  customDesignDesc: 'We support fully custom designs tailored to customer applications. We provide products that balance design and functionality.',
  diverseFinishes: 'Diverse Finishes',
  diverseFinishesDesc: 'We support various surface treatments including plating, painting, and polishing. We achieve beautiful appearance and durability.',
  smallLotSupport: 'Small Lot Support',
  smallLotSupportDesc: 'We flexibly support from prototypes to small lot production. We accept orders from individual customers.',
  shortDelivery: 'Short Delivery',
  shortDeliveryDesc: 'With extensive experience and efficient production systems, we can deliver in short lead times.',
  usedMaterials: 'Used Materials',
  metalMaterials: 'Metal Materials',
  brassWire: 'Brass wire',
  surfaceTreatment: 'Surface Treatment',
  goldPlating: 'Gold plating',
  silverPlating: 'Silver plating',
  nickelPlating: 'Nickel plating',
  chromePlating: 'Chrome plating',
  variousPainting: 'Various painting',
  specialMaterials: 'Special Materials',
  colorWire: 'Color wire',
  otherConsultation: 'Others negotiable',
  qualityService: 'Quality & Service',
  designConsultation: 'Design Consultation',
  designConsultationDesc: 'Expert staff support from design stage',
  prototypeSupport: 'Prototype Support',
  prototypeSupportDesc: 'Prototype production from 1 piece',
  qualityGuarantee: 'Quality Guarantee',
  qualityGuaranteeDesc: 'Quality assurance through 100% inspection',
  rapidDelivery: 'Rapid Delivery',
  rapidDeliveryDesc: 'Manufacturing and delivery in short lead times',
  contactMessage: 'Feel free to contact us',
  contactSubMessage: 'We accept even the smallest inquiries',
  
  // Contact page
  'contact.title': 'Contact Us',
  'contact.subtitle': 'Feel free to consult us about anything related to springs',
  'contact.intro1': 'All products are made to order, and we support everything from prototypes to mass production.',
  'contact.intro2': 'If you have drawings or actual products, please let us know.',
  'contact.requiredNote': '* Please fill in all items marked with an asterisk.',
  'contact.formTitle': 'Contact Form',
  'contact.companyName': 'Company Name',
  'contact.department': 'Department',
  'contact.fullName': 'Full Name',
  'contact.address': 'Address',
  'contact.telephone': 'Telephone',
  'contact.email': 'Email Address',
  'contact.specification': 'Specification',
  'contact.preferredDeliveryDate': 'Preferred Delivery Date',
  'contact.preferredUnitPrice': 'Preferred Unit Price',
  'contact.characters': 'characters',
  'contact.submit': 'Submit',
  'contact.submitting': 'Submitting...',
  'contact.submitSuccess': 'Your inquiry has been received. Thank you.',
  'contact.submitError': 'Submission failed. Please try again.',
  'contact.requiredFields': 'Please fill in all required fields.',
  'contact.specificationLimit': 'Please enter specifications within 500 characters.',
  'contact.urgentContact': 'For urgent inquiries',
  'contact.urgentContactDesc': 'We also accept inquiries by phone and fax.',
  'contact.phone': 'Phone',
  'contact.fax': 'Fax',
  
  // Recruit page
  'recruit.title': 'Recruitment Information',
  'recruit.subtitle': 'We are looking for people with flexibility and creative thinking',
  'recruit.intro': 'We are looking for spring-like people with flexibility and creative thinking. We also welcome those who wish to return to their hometown for employment.',
  'recruit.jobListings': 'Job Listings',
  'recruit.tokyoOffice': 'Tokyo Head Office Factory',
  'recruit.ogawaraFactory': 'Ogawara Factory',
  'recruit.akitaFactory': 'Akita Ota-machi Factory',
  'recruit.location': 'Location',
  'recruit.positions': 'Positions',
  'recruit.salary': 'Starting Salary',
  'recruit.person': 'person',
  'recruit.yen': 'yen',
  'recruit.university': 'University graduate',
  'recruit.technical': 'Technical college/Vocational school graduate',
  'recruit.highSchool': 'High school graduate',
  'recruit.graduate': 'Graduate school',
  'recruit.tokyoAddress': '5-3-18 Omori Minami, Ota-ku, Tokyo',
  'recruit.ogawaraAddress': '1-1 Kinecho, Ogawara-machi, Shibata-gun, Miyagi',
  'recruit.akitaAddress': '182-4 Kitabiraki, Sainai, Ota-machi, Daisen-shi, Akita',
  'recruit.commonInfo': 'Common Information',
  'recruit.salaryIncrease': 'Salary Increase',
  'recruit.salaryIncreaseDetail': 'Once a year (April)',
  'recruit.bonus': 'Bonus',
  'recruit.bonusDetail': 'Twice a year (July, December): Based on performance',
  'recruit.workingHours': 'Working Hours',
  'recruit.workingHoursDetail': '8:30-17:30 (including 70-minute break) May vary by location and department',
  'recruit.holidays': 'Holidays',
  'recruit.holidaysDetail1': 'Two days off per week',
  'recruit.holidaysDetail2': '113 annual holidays (according to company calendar)',
  'recruit.vacation': 'Vacation',
  'recruit.vacationDetail1': 'Annual paid leave (as stipulated by law)',
  'recruit.vacationDetail2': 'Special leave (marriage, bereavement, relocation, childbirth, etc.)',
  'recruit.jobType': 'Job Type',
  'recruit.jobTypeDetail': 'Production engineering, development, production management (material procurement, outsourcing management, quality/process management, etc.), administration (sales, general affairs)',
  'recruit.benefits': 'Benefits',
  'recruit.benefitsDetail': 'Complete social insurance, retirement benefit system, corporate pension system, qualification acquisition support system, qualification acquisition reward system, simple insurance (Japan Post), childcare leave system, birthday presents, etc.',
  'recruit.companyVideo': 'Company Introduction Video',
  'recruit.videoNotSupported': 'Your browser does not support the video tag.',
  'recruit.applicationForm': 'Application Form',
  'recruit.fullName': 'Full Name',
  'recruit.email': 'Email Address',
  'recruit.telephone': 'Telephone',
  'recruit.address': 'Address',
  'recruit.education': 'Education',
  'recruit.selectEducation': 'Please select',
  'recruit.desiredPosition': 'Desired Position',
  'recruit.desiredLocation': 'Desired Location',
  'recruit.selectLocation': 'Please select',
  'recruit.message': 'Self-introduction & Motivation',
  'recruit.characters': 'characters',
  'recruit.submit': 'Apply',
  'recruit.submitting': 'Submitting...',
  'recruit.submitSuccess': 'Thank you for your application. Our staff will contact you shortly.',
  'recruit.submitError': 'Submission failed. Please try again.',
  'recruit.requiredFields': 'Please fill in all required fields.',
  'recruit.messageLimit': 'Please enter your message within 500 characters.',
  'recruit.contactInfo': 'Contact Information',
  'recruit.contactAddress': '5-3-18 Omori Minami, Ota-ku, Tokyo 143-0013',
  'recruit.contactDepartment': 'Tokyo Head Office, General Affairs Department',
  'recruit.contactTel': 'Tel: +81-3-3743-0231 (Main)',
  'recruit.contactFax': 'Fax: +81-3-3743-0235',
  
  // Company Message page
  'message.title': 'Message from the President',
  'message.subtitle': 'Aiming to be a company needed by customers',
  'message.greeting': 'Thank you for visiting our website.',
  'message.content1': 'Komatsu Spring Industrial Co., Ltd. was founded in 1941 and incorporated in 1952. For over 80 years, we have been manufacturing precision springs as a specialized manufacturer.',
  'message.content2': 'Our corporate philosophy is "to be needed by customers." To achieve this, we have consistently pursued "customer-first principles" and have been committed to manufacturing high-quality springs.',
  'message.content3': 'Springs are small components, but they play important roles in various products. From industrial equipment to medical devices, electronic equipment, and daily necessities, our springs are used in a wide range of fields.',
  'message.content4': 'We accept orders from a single prototype to mass production, and respond flexibly to customer needs. We also have a system in place to maintain stable quality and meet delivery deadlines.',
  'message.content5': 'In the future, we will continue to improve our technology and provide products that satisfy our customers. We look forward to your continued support.',
  'message.president': 'President & CEO',
  'message.presidentName': 'Makiko Komatsu',
  
  // Company Office page
  'office.title': 'Locations',
  'office.subtitle': 'Nationwide production and sales network',
  'office.tokyoTitle': 'Tokyo Head Office Factory',
  'office.tokyoAddress': '5-3-18 Omori Minami, Ota-ku, Tokyo 143-0013',
  'office.tokyoTel': 'Tel: +81-3-3743-0231 (Main)',
  'office.tokyoFax': 'Fax: +81-3-3743-0235',
  'office.tokyoAccess': 'Access',
  'office.tokyoAccessDetail': '15 minutes walk from JR Omori Station / 10 minutes walk from Keikyu Tachiaigawa Station',
  'office.ogawaraTitle': 'Ogawara Factory',
  'office.ogawaraAddress': '1-1 Kinecho, Ogawara-machi, Shibata-gun, Miyagi 989-1246',
  'office.ogawaraTel': 'Tel: +81-224-53-2336',
  'office.ogawaraFax': 'Fax: +81-224-53-2337',
  'office.ogawaraAccessDetail': '5 minutes by car from JR Ogawara Station',
  'office.akitaTitle': 'Akita Ota-machi Factory',
  'office.akitaAddress': '182-4 Kitabiraki, Sainai, Ota-machi, Daisen-shi, Akita 019-1601',
  'office.akitaTel': 'Tel: +81-187-88-1333',
  'office.akitaFax': 'Fax: +81-187-88-1334',
  'office.akitaAccessDetail': '10 minutes by car from JR Kamishinjo Station',
  
  // Company History page
  'history.title': 'Corporate History',
  'history.subtitle': 'Over 80 years of history and tradition',
  'history.1941': 'May 1941: Founded as Komatsu Spring Manufacturing in Omori, Ota-ku, Tokyo',
  'history.1952': 'December 1952: Incorporated as Komatsu Spring Industrial Co., Ltd.',
  'history.1965': 'April 1965: Established Ogawara Factory in Miyagi Prefecture',
  'history.1985': 'March 1985: Established Akita Ota-machi Factory',
  'history.2002': 'February 2002: Acquired ISO 9001:2000 certification',
  'history.2007': 'January 2007: Acquired Eco-Action 21 certification',
  'history.2015': 'Transitioned to ISO 9001:2015',
  'history.present': 'Present: Operating 3 factories nationwide, manufacturing precision springs',
  
  // Company CSR page
  'csr.title': 'Quality Policy / Environmental Policy',
  'csr.subtitle': 'Commitment to quality and the environment',
  'csr.qualityPolicyTitle': 'Quality Policy',
  'csr.isoRegistration': 'Registration Date: February 1, 2002',
  'csr.isoNumber': 'Registration Number: JQA-QM7736',
  'csr.qualityContent1': 'In the manufacturing activities of "springs" carried out by Komatsu Spring Industrial Co., Ltd., with "to be needed by customers" as our management philosophy and under the basic policy of "thorough customer-first principles," we will continue to simultaneously pursue the principles of corporate development: "growth and expansion" and "stability."',
  'csr.qualityContent2': 'Future challenges include improving technology as a manufacturer of ultra-precision springs along with the rapid evolution of the precision equipment industry, and with flexible thinking, achieving quality uniformity, strict adherence to delivery dates, and cost optimization, while ensuring the necessary profits for corporate survival.',
  'csr.qualityContent3': 'We establish a quality policy that includes a commitment to conformity with customer requirements and continuous improvement of the effectiveness of the quality management system.',
  'csr.qualityStatement': '"Making it our business to meet customer demands and continuing to provide products called trust"',
  'csr.qualityContent4': 'This quality policy is the essence of our business, and it is fundamental that all employees understand this policy and ensure the reliable provision of intended products and services. Each person can achieve intended results by reliably implementing what has been decided and taking responsibility for their activities.',
  'csr.qualitySignature': 'Komatsu Spring Industrial Co., Ltd. President & CEO Makiko Komatsu',
  'csr.environmentalPolicyTitle': 'Environmental Management Policy',
  'csr.ecoRegistration': 'Certification/Registration Date: January 18, 2007',
  'csr.ecoNumber': 'Certification Number: 0001270',
  'csr.philosophy': '1. Corporate Philosophy',
  'csr.philosophyStatement': '"To be needed by customers"',
  'csr.philosophyContent': 'For us to be eternal, we must continue to be strongly needed by customers. In any environment, by creating superior "springs" with superior technology, we contribute to society through our company. Based on the philosophy of Eco-Action 21, considering "coexistence with the earth," we clarify the environmental impacts related to all our business operations and aim for environmentally friendly corporate activities.',
  'csr.policy2': '2. To grow into a better evolved organization through environmental management, we organize future management challenges (external and internal to the organization) and opportunities, and overcoming challenges becomes an opportunity for business development. We review challenges and opportunities that change depending on business content, circumstances surrounding the business, and the relationship between business and the environment as necessary.',
  'csr.policy3': '3. Align the corporate philosophy with environmental burdens in business activities and identify priority areas to address.',
  'csr.policy3Item1': '1) Reduction of electricity, gas, and gasoline to suppress CO₂ emissions',
  'csr.policy3Item2': '2) Waste separation, recycling, and paper reduction to suppress waste emissions',
  'csr.policy3Item3': '3) Water conservation to reduce usage',
  'csr.policy3Item4': '4) Reduction of chemical substance usage',
  'csr.policy3Item5': '5) Efficient use of raw materials to reduce manufacturing waste',
  'csr.policy3Item6': '6) Promotion of green procurement',
  'csr.policy3Item7': '7) Understanding product-contained chemical substances and prohibiting their inclusion and use',
  'csr.policy4': '4. Through environmental management activities, we strive for continuous improvement of environmental goals and environmental plans, and aim to step up environmental management.',
  'csr.policy5': '5. We pledge to comply with environmental laws and regulations.',
  'csr.policy6': '6. We will use displays, meetings, morning assemblies, etc. to ensure that all employees understand the content of the environmental management policy and can work on it.',
  'csr.co2Title': 'CO₂ Reduction Initiatives',
  'csr.co2Intro': 'Komatsu Spring Industrial Co., Ltd. is actively working to reduce CO₂ emissions toward the realization of a sustainable society. We consider environmental consideration to be a corporate responsibility and are advancing the following specific measures.',
  'csr.currentInitiatives': 'Current Initiatives',
  'csr.initiative1Title': '・Switched 100% of Ogawara Factory electricity to renewable energy',
  'csr.initiative1Detail': 'By using electricity derived from renewable energy, we have significantly reduced CO₂ emissions associated with factory operations.',
  'csr.initiative2Title': '・Company-wide LED lighting',
  'csr.initiative2Detail': 'Introduced LEDs that consume less power than conventional lighting, achieving energy savings.',
  'csr.initiative3Title': '・Introduction of electric vehicles (1 unit)',
  'csr.initiative3Detail': 'Converted some company vehicles to EVs, reducing environmental burden associated with transportation.',
  'csr.initiative4Title': '・Activities as "HTT Declaration Company (Tokyo)"',
  'csr.initiative4Detail': 'Publicly announced to Tokyo our stance on promoting energy saving, energy creation, and energy storage, strengthening initiatives.',
  'csr.initiative5Title': '・Participation in "Ota Cool Action (Ota Ward)"',
  'csr.initiative5Detail': 'Participating in regional environmental activities, aiming for sustainable community development together with the local area.',
  'csr.futureInitiatives': 'Future Plans',
  'csr.future1Title': '・Promoting company-wide transition to renewable energy plans',
  'csr.future1Detail': 'We will switch not only factories but also business offices and offices to renewable energy.',
  'csr.future2Title': '・Updating head office air conditioning equipment to energy-saving type',
  'csr.future2Detail': 'We will replace old air conditioning equipment with highly efficient energy-saving types to reduce power consumption.',
  'csr.conclusion': 'Through these activities, Komatsu Spring Industrial Co., Ltd. will contribute to the realization of a sustainable future while minimizing environmental burden.',
};
